const BRAND_DEFINITION_TASKS_SORTING_CRITERIA = {
  MODIFIED_DATE: 'MODIFIED_DATE',
}

export default BRAND_DEFINITION_TASKS_SORTING_CRITERIA
